#import "../fragments/mcfx-company-fragment.graphql"

query GetMcfxCompany($id: ID!) {
    mcfxCompany(id: $id) {
        ...McfxCompanyFragment
    }
}
